import { SpanKind } from '@opentelemetry/api';

// Semantic Name Attributes the webapps ought to attempt initializing
// See Web-App example within https://seequent.atlassian.net/l/cp/Gx4GaRsr
export const ATTRIBUTE_ACTIVITY_TYPE = 'activity.type';
export const ATTRIBUTE_CLIENT_ID = 'client.id';
export const ATTRIBUTE_CLIENT_SCOPES = 'client.scopes';
export const ATTRIBUTE_CLIENT_ADDRESS = 'client.address';
export const ATTRIBUTE_DEPLOY_ENV = 'deployment.environment';
export const ATTRIBUTE_DEPLOY_HUB_CODE = 'deployment.hub_code';
export const ATTRIBUTE_DEPLOY_HUB_ID = 'deployment.hub_id';
export const ATTRIBUTE_EVENT_NAME = 'event.name';
export const ATTRIBUTE_SESSION_ID = 'session.id';
export const ATTRIBUTE_USER_ID = 'user.id';
export const ATTRIBUTE_USER_ORG_ID = 'user.org.id';
export const ATTRIBUTE_USER_ORG_ROLE = 'user.org.role';
export const ATTRIBUTE_USER_ULT_SITE = 'user.ultimate_site';
export const ATTRIBUTE_USER_WS_ROLE = 'user.workspace.role';
export const ATTRIBUTE_USER_COUNTRY = 'user.usage_country_iso';
export const ATTRIBUTE_WS_ID = 'workspace.id';
export const ATTRIBUTE_WS_ORG_ID = 'workspace.org.id';
export const ATTRIBUTE_BROWSER_BRAND = 'browser.brand';
export const ATTRIBUTE_BROWSER_LANG = 'browser.language';
export const ATTRIBUTE_BROWSER_MOBILE = 'browser.mobile';
export const ATTRIBUTE_BROWSER_PLATFORM = 'browser.platform';
export const ATTRIBUTE_BROWSER_AGENT = 'user_agent.original';
export const PRODUCT_LOGGER_NAME = 'evo.product_metrics';

export const UNKNOWN = 'unknown';

export const URL_MATCH_COOKIELAW = /cdn\.cookielaw\.org/;
export const URL_MATCH_DATADOGHQ = /browser-intake-datadoghq\.com/;
export const URL_MATCH_LAUNCHDARKLY = /launchdarkly\.com/;
export const URL_MATCH_GOOGLE_ANALYTICS = /google-analytics\.com/;
export const URL_MATCH_SEGMENT = /segment\.io/;
export const URL_MATCH_BENTLEY = /bentley\.com/;
export const URL_MATCH_TRACES = /otel\.elastic\.seequent.com/;
export const URL_MATCH_ONETRUST = /onetrust\.com/;
export const URL_MATCH_CESIUM = /(api|ion)\.cesium\.com/;
export const URL_MATCH_VIRTUAL = /virtualearth\.net/;

// Avoiding traces on 3rd party integrations
export const FETCH_IGNORE_URLS: (string | RegExp)[] = [
    URL_MATCH_BENTLEY,
    URL_MATCH_CESIUM,
    URL_MATCH_COOKIELAW,
    URL_MATCH_DATADOGHQ,
    URL_MATCH_GOOGLE_ANALYTICS,
    URL_MATCH_LAUNCHDARKLY,
    URL_MATCH_SEGMENT,
    URL_MATCH_TRACES,
    URL_MATCH_VIRTUAL,
];
// LD traces requires EAP access, Bentley auth wont succeed w/ traces, and do not trace traces
export const XHR_IGNORE_URLS: (string | RegExp)[] = [
    URL_MATCH_BENTLEY,
    URL_MATCH_CESIUM,
    URL_MATCH_COOKIELAW,
    URL_MATCH_DATADOGHQ,
    URL_MATCH_LAUNCHDARKLY,
    URL_MATCH_ONETRUST,
    URL_MATCH_SEGMENT,
    URL_MATCH_TRACES,
    URL_MATCH_VIRTUAL,
];

/**
 * Forge a Request Transaction Span since APM transactions from a Client span show up as `unknown`
 * https://github.com/elastic/apm/blob/main/specs/agents/tracing-api-otel.md#transaction-type
 */
export const FORGE_REQUEST_TRANSACTION = {
    kind: SpanKind.SERVER,
    attributes: { 'http.scheme': 'render' },
};

/**
 * BaseLine Config: Omit<OpenTelemetryConfig, 'name | version'>
 */
export const PartialOpenTelemetryBaseConfig = {
    withConsoleExporter: true,
    fetchConfig: {
        ignoreUrls: FETCH_IGNORE_URLS,
    },
    xhrConfig: {
        ignoreUrls: XHR_IGNORE_URLS,
    },
};
